//npm packages
import "chosen-js";
import "chosen-js/chosen.css";
import "sticky-kit/dist/sticky-kit.js";
// import 'jarallax/dist/jarallax';

//custom components
import Header from "./components/Header";
import InstagramFeed from "./components/InstagramFeed";
import PageShare from "./components/PageShare";
import Sliders from "./components/Sliders";
import Modals from "./components/Modals";
import LocationMapMultiple from "./components/Maps";
import { isChrome } from "./components/Helpers";

//External
import "./external/bootstrap/bootstrap.tabs";
import "./external/bootstrap/bootstrap.tabs.css";
import "./external/timespace/jquery.timespace";
import "./external/timespace/jquery.timespace.light.css";
import "./external/cookiecuttr/jquery.cookiecuttr";
// import './external/cookiecuttr/jquery.cookiecuttr.css';
import "./external/lazyload";

/**
 * browser-deeplink v0.1
 *
 * Author: Hampus Ohlsson, Nov 2014
 * GitHub: http://github.com/hampusohlsson/browser-deeplink
 *
 * MIT License
 */

!(function(n, e) {
	"function" == typeof define && define.amd
		? define("deeplink", e(n))
		: "object" == typeof exports
			? (module.exports = e(n))
			: (n.deeplink = e(n));
})(window || this, function(n) {
	"use strict";
	if (n.document && n.navigator) {
		var e,
			t = {},
			a = {
				iOS: {},
				android: {},
				androidDisabled: !1,
				fallback: !0,
				fallbackToWeb: !1,
				delay: 1e3,
				delta: 500,
			},
			r = function(n, e) {
				var t = {};
				for (var a in n) t[a] = n[a];
				for (var a in e) t[a] = e[a];
				return t;
			},
			o = function() {
				var n = "itms-apps://itunes.apple.com/app/",
					e = t.iOS.appName,
					a = t.iOS.appId;
				return a && e ? n + e + "/id" + a + "?mt=8" : null;
			},
			i = function() {
				var n = "market://details?id=",
					e = t.android.appId;
				return e ? n + e : null;
			},
			d = function() {
				var n = {
					ios: t.iOS.storeUrl || o(),
					android: t.android.storeUrl || i(),
				};
				return n[t.platform];
			},
			l = function() {
				var n = {
					ios: t.iOS.fallbackWebUrl || location.href,
					android: t.android.fallbackWebUrl || location.href,
				};
				return n[t.platform];
			},
			f = function() {
				return navigator.userAgent.match("Android");
			},
			u = function() {
				return (
					navigator.userAgent.match("iPad") ||
					navigator.userAgent.match("iPhone") ||
					navigator.userAgent.match("iPod")
				);
			},
			c = function() {
				return f() || u();
			},
			p = function(n) {
				return function() {
					var e = t.fallbackToWeb ? l() : d(),
						a = t.delay + t.delta;
					"string" == typeof e &&
						Date.now() - n < a &&
						(window.location.href = e);
				};
			},
			s = function(n) {
				(t = r(a, n)),
					f() && (t.platform = "android"),
					u() && (t.platform = "ios");
			},
			m = function(n) {
				if (!c()) return !1;
				if (!f() || !t.androidDisabled) {
					if (f() && !navigator.userAgent.match(/Firefox/)) {
						var a = n.match(/([^:]+):\/\/(.+)$/i);
						(n = "intent://" + a[2] + "#Intent;scheme=" + a[1]),
							(n += ";package=" + t.android.appId + ";end");
					}
					(t.fallback || t.fallbackToWeb) &&
						(e = setTimeout(p(Date.now()), t.delay));
					var r = document.createElement("iframe");
					return (
						(r.onload = function() {
							clearTimeout(e),
								r.parentNode.removeChild(r),
								(window.location.href = n);
						}),
						(r.src = n),
						r.setAttribute("style", "display:none;"),
						document.body.appendChild(r),
						!0
					);
				}
			};
		return { setup: s, open: m };
	}
});

export default new class App {
	constructor() {
		this.screenWidth;
		this.screenHeight;
		this.body = $("body");
		this.html = $("html");

		this.pageShareWrapper = $(".page__share__wrapper");
		this.instagramSection = $(".js-instagram-section");
		this.mainHeader = $(".js-main-header");
		this.mainBanner = $(".js-main-banner");
		this.fancybox = $('[data-fancybox=""]');
		this.fancyboxGallery = $('[data-fancybox="images"]');
		this.stickyMap = $(".js-sticky-map");
		this.getSiblingHeight = $(".getSiblingHeight");

		this.stickySidebar = $(".js-sticky-sidebar");
		this.stickySidebarParent = $(".js-sticky-sidebar-parent");

		this.submitTrigger = $(".submitTrigger");
		this.fileInput = $('input[type="file"]');
		this.favoritesTimeline = $(".favoritesTimeline");
		this.favoritesTabs = $(".favoritesTabs");
		this.goToTop = $("#goToTop");
		// this.ucFormStick = $('.uc-form');

		$(document).ready(() => this.domReady());
	}

	domReady() {
		this.platformClasses();
		this.formsHelper();
		this.windowResize();
		$(window).resize(() => this.windowResize());
		$(window).scroll(() => this.windowScroll());

		new Modals();
		new Header(this.mainHeader);
		new LocationMapMultiple();

		new PageShare(this.pageShareWrapper);

		// new MainBanner(this.mainBanner);
		new InstagramFeed(this.instagramSection);
		new Sliders(this.body);
		// jarallax(document.querySelectorAll('.jarallax'), { speed: 0.2 });

		// $(".lazyload").lazyload();
		let images = document.querySelectorAll("[data-original]");
		let lazy = lazyload(images, { src: "data-original" });

		//scroll to top
		this.goToTop.click(function() {
			$("body,html").animate({
				scrollTop: 0,
			});
		});

		var inputEmail = $(
			".main-header__newsletter .MailingListSubscribe .mailing-list-email-input",
		);
		if (inputEmail.val() != "") {
			$('.main-header__newsletter label[for="email"]').css("opacity", 0);
		}
		var inputEmail2 = $(
			"#footerSubscription .MailingListSubscribe .mailing-list-email-input",
		);
		if (inputEmail2.val() != "") {
			$('.main-footer label[for="email"]').css("opacity", 0);
		}
		if (this.html.hasClass("ie9") || this.html.hasClass("ie8")) {
			$.fancybox.open({
				src: "#ie-modal",
				type: "inline",
			});
		}

		$.cookieCuttr({
			cookieAcceptButton: false,
			cookieAnalytics: false,
			cookieMessage: `<div class="cookieDiv"> <div class="cookieDiv__container container"> <div class="row"> <div class="col--10sm"> <h4 class="cookieDiv__title">Cookies on the Dubai Design Week website</h4> <p>We use cookies to maximise your experience and help us to understand how we can improve it. By continuing to use this website we assume you are agreeing to our use of cookies.</p></div><div class="col--2sm colRight"> <a href="#accept" class="button button__primary button__primary--yellow cc-cookie-accept"><span class="button__label">Continue</span></a> <a href="${CCM_BASE_URL +
				CCM_DISPATCHER_FILENAME}/cookie-policy" class="lm">Learn more</a> </div></div></div></div>`,
			cookieDiscreetPosition: "bottomleft",
		});

		//set cookie for site
		function setCookie(cname, cvalue) {
			var d = new Date();
			d.setTime(d.getTime() + 216000000);
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
		}
		$(window).on("load", function() {
			setTimeout(function() {
				if ($("#instafeed").find("li").length > 0) {
					$(".js-instagram-section").show();
				} else {
					$(".js-instagram-section").hide();
				}
			}, 500);
		});
		if ($("#favorites-modal").length > 0) {
			if (document.cookie.indexOf("visited=") == -1) {
				setCookie("visited", "1");

				$(window).on("load", function() {
					setTimeout(function() {
						$.fancybox.open({
							src: "#favorites-modal",
							type: "inline",
						});
					}, 8000);
				});
			}
		}
		// if($('.js-instagram-section #instafeed li').length < 0) {
		//     $('.js-instagram-section').hide();
		// }
		if ($(".home .show-login").length > 0) {
			var setTime = $("#login-modal").attr("data-settime");
			setTime = setTime * 1000;
			console.log("settime " + setTime);
			$(window).on("load", function() {
				setTimeout(function() {
					$.fancybox.open({
						src: "#login-modal",
						type: "inline",
					});
				}, setTime);
			});
		}

		// $(window).on('load', function(){
		//     if($('.home-page').length > 0 ) {
		//         setTimeout(function(){
		//             $.fancybox.open({
		//                 src  : '#favorites-modal',
		//                 type : 'inline'
		//             });
		//         }, 8000);
		//     }
		// });

		$('a[data-toggle="tab"]').on("shown.bs.tab", (e) => {
			if (this.stickyMap.length) {
				this.stickyMap.stick_in_parent({
					parent: ".js-sticky-map-parent",
					offset_top: 80,
				});
			}
		});

		this.stickySidebar.stick_in_parent({
			parent: ".js-sticky-sidebar-parent",
			offset_top: 80,
		});

		$(
			'.taking_part-page .formidable .formidable_row.row_2 input[type="radio"]',
		).on("click change", function(e) {
			$(
				".taking_part-page .formidable .formidable_row.row_2 .element,.taking_part-page .formidable .formidable_row.button_row",
			).show();
		});

		$(".formNextBtn").on("click", function() {
			$(
				'.taking_part-page .formidable .formidable_row.row_2 input[type="radio"]',
			).attr("checked", true);
			$(
				".taking_part-page .formidable .formidable_row.row_2 .element,.taking_part-page .formidable .formidable_row.button_row",
			).show();
		});
		let anchorTxt = $(".pageFiles__anchor").attr("href");
		$(".taking-part .formidable .checkbox label").html(
			`I have read the <a href="${anchorTxt}" target="_blank">Partner Information Pack</a> and understood Dubai Design Week terms and conditions.`,
		);
		$("#timelineItems").css("visibility", "hidden");

		this.favoritesTabs.find('a[data-toggle="tab"]').on("shown.bs.tab", (e) => {
			if (e.currentTarget.hash === "#favoritesTimeline") {
				this.favoritesTabs.addClass("isTimeline");
			} else {
				this.favoritesTabs.removeClass("isTimeline");
			}
		});
		console.log("here");

		this.favoritesTabs
			.find('a[href="#favoritesTimeline"]')
			.one("shown.bs.tab", (e) => {
				$("#timeline-loader").addClass("fancybox-loading");

				this.favoritesTimeline.each(function() {
					var event_data = [];
					$(this)
						.children(".timelineItem")
						.each(function() {
							event_data.push({
								start: parseInt(this.getAttribute("data-start")),
								end: parseInt(this.getAttribute("data-end")),
								title: this.getAttribute("data-title"),
								type: "Workshop" || this.getAttribute("data-type"),
								location: this.getAttribute("data-location"),
							});
						});
					$(this).timespace({
						maxWidth: 1400,
						markerWidth: 300,
						// startTime: 8,
						// use12HourTime: false,
						useTimeSuffix: true,
						selectedEvent: 0,
						data: {
							events: event_data,
						},
					});
				});
				setTimeout(function() {
					$("#timeline-loader").removeClass("fancybox-loading");
					$("#timelineItems").css("visibility", "visible");
					$(".timelineHeading").each(function() {
						$(this).html(this.getAttribute("data-title"));
					});
				}, 1000);
			});

		//footerSubscription
		// const userloggedIn = $('body').hasClass("logged-in") == true;
		// document.getElementById('btnSubscribe').addEventListener('click', function (e) {
		//     e.preventDefault();
		//     document.querySelector(this.getAttribute('href')).scrollIntoView({
		//         behavior: 'auto'
		//     });
		//     if(userloggedIn == false){
		//         document.querySelector('#footerSubscription input.mailing-list-email-input').focus();
		//     }
		// });

		// takepart page
		if (this.body.hasClass("takepart")) {
			var tpForm = location.href.split("#")[1];
			var tpLink = $("#ApplicationForm");
			if (tpForm === "ApplicationForm" && tpLink.length) {
				tpLink.click();
			}
		}

		if ($(".contentSidebar__container").length) {
			$("body").addClass("ox-none");
		}

		console.log("testing...");
		if ($("body").hasClass("getting_here-page")) {
			console.log("getting here ..");
			if ($(".inner-banner").length) {
				console.log("overwrite padding");
				$("body").addClass("overwrite-padding");
			}
		}
	}

	windowResize() {
		const iframe = $("#bannerIframe");

		if (iframe.length) {
			//video screen sizing
			const videocontainerHeight = $(window).height();
			const hdmoviewidth = $(window).width();
			const iframeAspectRatio = iframe.data("aspect-ratio") || 1.7777777778;
			const heightswitch = videocontainerHeight * iframeAspectRatio;
			const hdmovieml = (heightswitch - $(window).width()) / -2;

			if ($(window).width() < heightswitch) {
				iframe.height(videocontainerHeight);
				iframe.width(heightswitch);
				iframe.css({ top: "0px" });
				iframe.css({ left: hdmovieml });
			} else {
				const hdmovieheight = $(window).width() / iframeAspectRatio;
				iframe.height(hdmovieheight);
				iframe.width(hdmoviewidth);
				iframe.css({ left: "0px", top: "0" });
			}
			if (iframe.height() > videocontainerHeight) {
				const vertVideoCenter = (iframe.height() - videocontainerHeight) / 2;
				//$("iframe").css({'margin-top':'0px'});
				iframe.css({ top: "-" + vertVideoCenter + "px" });
			}
		}
		// this.getSiblingHeight.each(getSiblingHeight);
	}

	windowScroll() {
		this.goToTop.toggleClass(
			"active",
			$(window).scrollTop() > $(window).height() / 2,
		);
		// Urban Commissions button
		// if(this.ucFormStick.length){
		//     this.ucFormStick.toggleClass("stick",$(window).scrollTop() > (336));
		// }
	}

	formsHelper() {
		this.selects = $("select");
		this.loginInputs = $(".ccm-login-form .ccm-input-text");
		this.inputs = $("input, textarea").not('[type="checkbox"], [type="radio"]');

		this.inputs
			.on("focus", function() {
				$(this)
					.closest(".element")
					.addClass("active");
			})
			.on("blur change", function() {
				if ($(this).val() !== "") {
					$(this)
						.closest(".element")
						.addClass("active");
				} else {
					$(this)
						.closest(".element")
						.removeClass("active");
				}
			})
			.trigger("blur");

		if (isChrome) {
			this.loginInputs.each(function() {
				if ($(this).is(":-webkit-autofill") || $(this).val() != "") {
					$(this)
						.closest(".element")
						.addClass("active");
				}
			});
		}

		$("#button-submit").click(function() {
			$(this)
				.closest(".element")
				.find("#submit")
				.trigger("click");
		});
	}

	platformClasses() {
		//detect mobile platform
		if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
			this.body.addClass("ios-device");
		}
		if (navigator.userAgent.match(/Android/i)) {
			this.body.addClass("android-device");
		}

		//detect desktop platform
		if (navigator.appVersion.indexOf("Win") != -1) {
			this.body.addClass("win-os");
		}
		if (navigator.appVersion.indexOf("Mac") != -1) {
			this.body.addClass("mac-os");
		}

		//detect IE 10 and 11
		if (
			navigator.userAgent.indexOf("MSIE") !== -1 ||
			navigator.appVersion.indexOf("Trident/") > 0
		) {
			this.html.addClass("ie10");
		}

		//detect IE Edge
		if (/Edge\/\d./i.test(navigator.userAgent)) {
			this.html.addClass("ieEdge");
		}
	}
}();
function mobilemenu() {
	let screenWidth = $(window).width();
	let dropdownParent = $(".main-header__mainnav ul > li").find("ul");
	if (screenWidth < 767) {
		if (dropdownParent.length > 0) {
			dropdownParent.parent("li").append('<span class="dropdown-toggle"/>');
			dropdownParent.addClass("expand");
			dropdownParent
				.find("ul")
				.removeClass("expand")
				.addClass("multi-expand");
		}
		$("span.dropdown-toggle").on("click", function() {
			if (
				!$(this)
					.parent("li")
					.hasClass("open")
			) {
				$(".main-header__mainnav ul > li").removeClass("open");
				$(this)
					.parent("li")
					.addClass("open");
			} else {
				$(this)
					.parent("li")
					.removeClass("open");
			}
		});
	}
}
function headerNewsletter() {
	$("header .mailing-list-submit-button").attr("value", "Subscribe");
	setTimeout(function() {
		$("header .mailing-list-email-wrap.element").removeClass("active");
	}, 1000);
}
function equalHeight() {
	let screenWidth = $(window).width();
	if (screenWidth > 767) {
		var maxHeight = 0;
		var maxHeight2 = 0;
		$(
			".releases-view-page .pressDocumentsList.items .pressDocumentsList__item",
		).each(function() {
			if (
				$(this)
					.find(".pressDocumentsList__desc")
					.height() > maxHeight
			) {
				maxHeight = $(this)
					.find(".pressDocumentsList__desc")
					.height();
			}
			if (
				$(this)
					.find(".pressDocumentsList__title")
					.height() > maxHeight2
			) {
				maxHeight2 = $(this)
					.find(".pressDocumentsList__title")
					.height();
			}
		});
		$(
			".releases-view-page .pressDocumentsList__item .pressDocumentsList__title",
		).height(maxHeight2);
		$(
			".releases-view-page .pressDocumentsList__item .pressDocumentsList__desc",
		).height(maxHeight);
	}
}
deeplink.setup({
	iOS: {
		appId: "1435925730",
		appName: "dxbdw",
	},
	android: {
		appId: "com.tentwenty.dubaidesignweek",
	},
});

function clickHandler(uri) {
	deeplink.open(uri);
	return false;
}

var cookieBanner = document.cookie.indexOf("visited=true") == -1;
function smartBanner() {
	if (navigator.userAgent.match(/(iPhone)/)) {
		var iphoneCont = `<div id="smartbanner" class="iphoneapp showbanner"><div class="sb-container"><a href="javascript:void(0);" class="sb-close">&times;</a>
        <a href="https://itunes.apple.com/us/app/dxbdw/id1435925730?ls=1&mt=8" target="_blank"><span class="sb-icon"></span></a>
          <div class="sb-info">
            <span class="sb-title"></strong>DXBDW <i>4+</i></i></span>
            <span class="sb-intro">The guide to Dubai Design Week</span>
            <span class="sb-author">ART DUBAI FAIR FZ LLC</span>
            <span class="sb-store">Free</span>
          </div>
          <a href="https://itunes.apple.com/us/app/dxbdw/id1435925730?ls=1&mt=8" target="_blank" class="sb-button">
            <span>view</span>
          </a>
        </div>
    </div>`;
		$("body").append(iphoneCont);
	}
	if (navigator.userAgent.match(/Android/i)) {
		var iphoneCont = `<div id="smartbanner" class="android showbanner"><div class="sb-container"><a href="javascript:void(0);" class="sb-close">&times;</a>
          <a href="https://play.google.com/store/apps/details?id=com.tentwenty.dubaidesignweek" target="_blank"><span class="sb-icon"></span></a>
          <div class="sb-info">
            <span class="sb-title"></strong>DXBDW</span>
            <span class="sb-author">ART DUBAI FAIR FZ LLC</span>
            <span class="sb-store">FREE</span>
          </div>
          <a href="https://play.google.com/store/apps/details?id=com.tentwenty.dubaidesignweek" target="_blank" class="sb-button">
            <span>view</span>
          </a>
        </div>
    </div>`;
		$("body").append(iphoneCont);
	}
	$(document).on("click", ".sb-close", function() {
		//  $('#smartbanner').hide();
		//  cookieBanner = 1;
	});
}
$(document).ready(function() {
	$(".element").removeClass("active");
	// if (document.cookie.indexOf('visited=true') == -1) {
	//     var fifteenDays = 1000*60*60*24*2;
	//     var expires = new Date((new Date()).valueOf() +  fifteenDays);
	//     document.cookie = "visited=true;expires=" +  expires.toUTCString();
	//     smartBanner();
	// }

	$("a.footerSubscription").on("click", function(event) {
		var hash = $("#footerSubscription");
		$("html, body").animate(
			{
				scrollTop: $("#footerSubscription").offset().top,
			},
			800,
			function() {},
		);
		$(".mailing-list-email-input").focus();
		$(".main-header").removeClass("main-header--mobilemenuopen");
	});
});

// if the cookie is true, hide the initial message and show the other one
// smartBanner();

if ($.cookie("hide-after-click") == "yes") {
	$("#smartbanner").hide();
	$("#smartbanner").removeClass("showbanner");
}

// when clicked on â€œXâ€ icon do something
$(document).on("click", ".sb-close", function() {
	$(".wrapper").removeClass("smartbanner-show");
	$("#smartbanner").removeClass("showbanner");
	location.reload();
	$("#smartbanner").hide();
	$.cookie("hide-after-click", "yes", { expires: 2 });
	return false;
});

$(".main-footer__subscription #MailingListSubscribe88 a").click(function() {
	$.cookie("hide-after-click", "no", { expires: 2 });
});

if ($(".showbanner").length > 0) {
	$(".wrapper").addClass("smartbanner-show");
}

// newsletter hide settings
$(
	".smartbanner-show:not(.main-header--mobilemenuopen) .main-header__hamburger",
).on("click", function() {
	$("body,html").animate({
		scrollTop: 100,
	});
});
$(".smartbanner-show.main-header--mobilemenuopen .main-header__hamburger").on(
	"click",
	function() {
		$("body,html").animate({
			scrollTop: 0,
		});
	},
);

equalHeight();
headerNewsletter();
mobilemenu();
